export function initPressSlideshow() {
  const slideshow = document.querySelector("[data-press-slideshow]");
  if (!slideshow) return;

  const slides = slideshow.querySelectorAll("[data-press]");
  if (slides.length <= 1) return;

  let currentIndex = 0;
  let slideshowInterval;
  const SLIDE_DURATION = 8000;

  function showSlide(index) {
    // Remove active class from current slide
    const currentSlide = slideshow.querySelector(".is-active");
    currentSlide?.classList.remove("is-active");

    // Add active class to new slide
    slides[index].classList.add("is-active");
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  function startSlideshow() {
    slideshowInterval = setInterval(nextSlide, SLIDE_DURATION);
  }

  function pauseSlideshow() {
    clearInterval(slideshowInterval);
  }

  // Event listeners for mouse and touch
  slideshow.addEventListener('mouseenter', pauseSlideshow);
  slideshow.addEventListener('mouseleave', startSlideshow);
  slideshow.addEventListener('touchstart', pauseSlideshow);
  slideshow.addEventListener('touchend', startSlideshow);

  // Start the slideshow initially
  startSlideshow();
}
